// Rail.jsx — R2: il rail dei 6 moduli PARI GRADO (design §11 R2, audit lente 4.A).
// Ordine FISSO = RAIL_ORDER (Cruscotto in testa), icona+etichetta PIENA dal
// glossario per TUTTI (mai 'Proc'/'Amm'/'Cont'), badge dal bus (accumulati in
// host), stato attivo visibile identico per tutti. Solo desktop (≥768px, CSS);
// su mobile comanda la MobileBar. Auth-gated dal frame (§5): mai sul login.
// Il rail legacy #amm-rail resta nel DOM (nascosto da body.shell-rail-v2): i
// click programmatici di proxyRail/host continuano a passare di lì.
// Ondata 6: il FONDO del rail ospita la zona utente (pill iniziali con nome al
// tooltip, lingua EN/IT, logout con conferma) — migrata dal footer del sottomenù
// al MENU PRINCIPALE. Resa unica in UserZone.jsx (stessa dei modsheet mobile).

import React from 'react';
import { RAIL_ORDER, railVisible } from './registry.js';
import { moduleLabel, label } from './glossary.js';
import { UserZone } from './UserZone.jsx';

// Icone inline 24x24 stroke (nessun testo: le label vengono dal glossario).
const STROKE = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

const ICONS = {
  // Cruscotto: tachimetro
  dash: (
    <svg viewBox="0 0 24 24" {...STROKE} aria-hidden="true">
      <path d="M4 14a8 8 0 1 1 16 0" />
      <path d="M12 14l3.5-3.5" />
      <path d="M3 18h18" />
    </svg>
  ),
  // Procurement: carrello
  proc: (
    <svg viewBox="0 0 24 24" {...STROKE} aria-hidden="true">
      <circle cx="9" cy="20" r="1.4" />
      <circle cx="17" cy="20" r="1.4" />
      <path d="M3 4h2l2.4 12h10.2l2.4-8H6" />
    </svg>
  ),
  // Amministrazione: calendario scadenze
  amm: (
    <svg viewBox="0 0 24 24" {...STROKE} aria-hidden="true">
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M8 3v4M16 3v4M4 10h16" />
      <path d="M9.5 15l2 2 3.5-3.5" />
    </svg>
  ),
  // Contabilità: calcolatrice
  cont: (
    <svg viewBox="0 0 24 24" {...STROKE} aria-hidden="true">
      <rect x="5" y="3" width="14" height="18" rx="2" />
      <path d="M8.5 7.5h7" />
      <path d="M8.5 12h.01M12 12h.01M15.5 12h.01M8.5 15.5h.01M12 15.5h.01M15.5 15.5h.01" />
    </svg>
  ),
  // Posta: busta
  email: (
    <svg viewBox="0 0 24 24" {...STROKE} aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3.5 7l8.5 6 8.5-6" />
    </svg>
  ),
  // SOP: elenco procedure con spunta
  sop: (
    <svg viewBox="0 0 24 24" {...STROKE} aria-hidden="true">
      <path d="M4 6h.01M4 12h.01M4 18h.01" />
      <path d="M8 6h12M8 12h12M8 18h6" />
      <path d="M17.5 16.5l1.5 1.5 3-3" />
    </svg>
  ),
  // Centralino: cornetta telefonica (modulo LIVE dal ramo task/centralino —
  // l'icona vive qui perché il rail è renderizzato da questa shell)
  tel: (
    <svg viewBox="0 0 24 24" {...STROKE} aria-hidden="true">
      <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8.1 9.5a16 16 0 0 0 6 6l1.1-1.1a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z" />
    </svg>
  ),
  // Fatturazione: documento con righe e importo
  fatt: (
    <svg viewBox="0 0 24 24" {...STROKE} aria-hidden="true">
      <path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3z" />
      <path d="M9 8h6M9 12h6M9 16h3" />
    </svg>
  ),
};

export function Rail({ host }) {
  const [, setTick] = React.useState(0);
  React.useEffect(() => host.subscribe(() => setTick((t) => t + 1)), [host]);

  const current = host.currentModule();

  return (
    <nav id="shell-rail" aria-label={label('shell.rail.aria')}>
      {RAIL_ORDER.filter((id) => railVisible(id)).map((id) => {
        const lbl = moduleLabel(id);
        const badge = host.moduleBadge(id);
        const isActive = current === id;
        return (
          <button
            key={id}
            type="button"
            className={'sr-btn' + (isActive ? ' active' : '')}
            title={lbl}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => host.activate(id)}
          >
            <span className="sr-ic">{ICONS[id]}</span>
            <span className="sr-lbl">{lbl}</span>
            {badge > 0 && <span className="sr-badge">{badge > 99 ? '99+' : badge}</span>}
          </button>
        );
      })}
      <div className="sr-foot">
        <UserZone host={host} variant="rail" />
      </div>
    </nav>
  );
}
